import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UsuarioEsquema } from 'src/app/usuarioEsquema';
import { Usuario } from 'src/app/usuario';
import { ConfInicialesService } from 'src/app/servicios/conf-iniciales.service';
import { NomencDistricen } from "../nominterfaces/nomencdistricen";
import { NomDetDistricen } from "../nominterfaces/nomdetdistricen";

@Injectable({
  providedIn: 'root'
})
export class NomdistricencostosService {
  public encdistricen: NomencDistricen[] = [];
  //public detregcomp: Cxcdetregcomp[][] = [];
  //public detdistricen: NomDetDistricen[][] = [];

  public _detdistricen: NomDetDistricen[];
  get detdistricen(): NomDetDistricen[] {
    return this._detdistricen;
  }

  set detdistricen(value: NomDetDistricen[]) {
    this._detdistricen = value;
  }
  private way: string;

  constructor(private http: HttpClient,
    public usuarioEsquema: UsuarioEsquema,
    public usuario: Usuario,
    private confIniciales: ConfInicialesService) {
    this.way = sessionStorage.getItem('way');

  }

  buscarPeriodo() {

    return this.http.post<any[]>(this.way + '/nom/liquidacionrol/poia6cwo7pz8qw3', {
      elementos: {
        p_com_codigo: '01'
      },
    }, this.confIniciales.httpOptions()).toPromise();

  }
  FunListaTipRol() {

    return this.http.post<any[]>(this.way + '/nom/nomdistricen/3fd7acb9d535d8', {
      elementos: {
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getemptipodep(strtipodep, encreg) {

    return this.http.post<any[]>(this.way + '/nom/nomdistricen/10775d6cd5f2af000', {
      elementos: {
        tipodep: strtipodep,
        encregcen: encreg
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  insertencabezado(reg) {

    return this.http.post<any[]>(this.way + '/nom/nomdistricen/4afc76faa75d8c0000000000', {
      elementos: {
        p_periodo_codigo: reg.PERIODO_CODIGO,
        p_com_codigo: '01',
        p_encdiscen_codigo: reg.ENCDISCEN_CODIGO,
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  insertdetalle(reg) {

    return this.http.post<any[]>(this.way + '/nom/nomdistricen/4afc76faa6bbac0000000000', {
      elementos: {
        p_encdiscen_codigo: reg.ENCDISCEN_CODIGO,
        p_com_codigo: '01',
        p_emp_codigo: reg.EMP_CODIGO,
        p_detdiscen_linea: reg.DETDISCEN_LINEA
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getenccendis(reg) {

    return this.http.post<any[]>(this.way + '/nom/nomdistricen/41dd75d8d973bc00000', {
      elementos: {
        p_encdiscen_codigo: reg,
        p_com_codigo: '01'
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getdetcendis(reg) {

    return this.http.post<any[]>(this.way + '/nom/nomdistricen/41dd6bbad973bc00000', {
      elementos: {
        p_encdiscen_codigo: reg,
        p_com_codigo: '01'
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  borrarRegistro(reg) {

    return this.http.post<any[]>(this.way + '/nom/nomdistricen/3ab2b4aea75d8e0000000000', {
      elementos: {
        p_encdiscen_codigo: reg,
        p_com_codigo: '01'
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  validacedulas(arreglo) {

    return this.http.post<any[]>(this.way + '/nom/nomdistricen/7d559354e', {
      elementos: {
        arreglo
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  validacentros(arreglo) {

    return this.http.post<any[]>(this.way + '/nom/nomdistricen/7d559355896hh4e', {
      elementos: {
        arreglo
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }

  insertdetalleExcel(item, reg) {

    return this.http.post<any[]>(this.way + '/nom/nomdistricen/95f8edf55dddd8000000', {
      elementos: {
        p_encdiscen_codigo: reg,
        p_emp_rucide: item.CEDULA,
        p_com_codigo: '01',
        p_cen_codigo: item.CENCODIGO,
        p_trndiscen_dias: item.DIAS,

      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  eliminadetalleall(reg) {

    return this.http.post<any[]>(this.way + '/nom/nomdistricen/1d595a5757777700000000000000', {
      elementos: {
        p_registro: reg
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  validaperiodo(reg) :Promise<any[]>{
    return this.http.post<any[]>(this.way + '/nom/nomdistricen/662fcf57aadba0000000', {
      elementos: {
        p_registro: reg
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  validaperiodoA(reg) :Promise<any[]>{
    return this.http.post<any[]>(this.way + '/nom/nomdistricen/faab26ab2edcb000000000000', {
      elementos: {
        p_registro: reg
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  eliminanomdistri(reg) :Promise<any[]>{
    return this.http.post<any[]>(this.way + '/nom/nomdistricen/1d595a5755f16700000000000000', {
      elementos: {
        p_encdiscen_codigo: reg,
        p_com_codigo:'01'
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getdetrodistri(reg) :Promise<any[]>{
    return this.http.post<any[]>(this.way + '/nom/nomdistricen/41dd6bbbbc55b400000', {
      elementos: {
        p_encdiscen_codigo: reg,
        p_com_codigo:'01'
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
}
